module.exports = __webpack_public_path__ + "img/right-label-other.23a909a7.png";